import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/menu/joe.png'


const _withScopeId = n => (_pushScopeId("data-v-adc4d07a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bird-view-tooltip" }, [
  /*#__PURE__*/_createTextVNode("視点"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("切替")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, null, -1))
const _hoisted_5 = { class: "right" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "id" }
const _hoisted_9 = { class: "is-apply" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "medal none" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separate" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trophy" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "current" }, "00", -1))
const _hoisted_14 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "point-desc" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "joe" }, null, -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  ref: "audio",
  src: "sounds/bgm.mp3",
  loop: ""
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "on" }, "ON"),
  /*#__PURE__*/_createTextVNode(" / "),
  /*#__PURE__*/_createElementVNode("span", { class: "off" }, "OFF")
], -1))
const _hoisted_24 = { class: "right" }
const _hoisted_25 = { class: "body" }
const _hoisted_26 = { class: "joe" }
const _hoisted_27 = { class: "message" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" ジョーズ・タウンにようこそ。")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("一緒に楽しみましょう！ ")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/virtual/modify/" }, "会員情報の変更")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://form.ichijo.co.jp/m?f=38" }, "パスワードの変更")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/virtual/avatar/" }, "アバター・ニックネームの変更")
], -1))
const _hoisted_36 = {
  href: "/virtual/faq/",
  target: "_blank",
  ref: "noopener"
}
const _hoisted_37 = {
  href: "/inquiry/",
  target: "_blank",
  ref: "noopener"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://form.ichijo.co.jp/m?f=40" }, "退会する")
], -1))
const _hoisted_39 = { class: "note" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sns" }, " ジョーズ・タウンのキャラクターや街並みのスクリーンショットは自由にSNSに投稿していただけます。「テクノロジーミュージアム」等のパビリオン内につきましてはお控えください。 ", -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" ※プライバシーポリシーは")
const _hoisted_42 = {
  href: "/privacy/",
  target: "_blank",
  ref: "noopener"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" ※利用規約は")
const _hoisted_44 = {
  href: "/virtual/useagree/",
  target: "_blank",
  ref: "noopener"
}
const _hoisted_45 = {
  key: 4,
  class: "dialog"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ログアウトしますか？", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "data:image/png;base64,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" }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "data:image/png;base64,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" }, null, -1))
const _hoisted_50 = [
  _hoisted_49
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({ demo: _ctx.demo }),
    "data-id": "park-header"
  }, [
    (_ctx.isMenuOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cover",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.isMapOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "cover",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMap && _ctx.toggleMap(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.isPointDescOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "cover",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePointDesc && _ctx.togglePointDesc(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.isCampaignWindow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "cover",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isCampaignWindow = false))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass([{ disable: !_ctx.isMap }, "map-button"]),
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleMap && _ctx.toggleMap(...args)))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass([{ bird: _ctx.birdView, normal: !_ctx.birdView }, "bird-view-button"]),
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleBirdView && _ctx.toggleBirdView(...args)))
      }, _hoisted_3, 2)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_ctx.campaignList.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([{ close: !_ctx.isCampaignWindow, applied: _ctx.isCampaignApplied }, "campaign-button"]),
            disabled: _ctx.isCampaignApplied,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isCampaignWindow = !_ctx.isCampaignWindow))
          }, null, 10, _hoisted_6))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", {
        class: "campaign-window",
        onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass([{ apply: item.isApply }, "campaign"]),
            onClick: ($event: any) => (_ctx.selectCampaign(item))
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.type === "NewMemberCampaign"
                ? "新規登録キャンペーン"
                : "ログインキャンペーン"), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.isApply ? "応募済み" : "未応募"), 1)
          ], 10, _hoisted_7))
        }), 128))
      ], 512), [
        [_vShow, _ctx.isCampaignWindow]
      ]),
      _createElementVNode("div", {
        class: "present-button",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openPresent && _ctx.openPresent(...args)))
      }),
      _createElementVNode("div", {
        class: "point",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.togglePointDesc && _ctx.togglePointDesc(...args)))
      }, _hoisted_14),
      _withDirectives(_createElementVNode("div", _hoisted_15, _hoisted_18, 512), [
        [_vShow, _ctx.isPointDescOpen]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{ open: _ctx.isMenuOpen }, "menu"])
      }, [
        _createElementVNode("div", {
          class: "hamburger",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }, _hoisted_20)
      ], 2)
    ]),
    _createElementVNode("div", {
      ref: "menuList",
      class: _normalizeClass([{ open: _ctx.isMenuOpen }, "menu-list"])
    }, [
      _createElementVNode("div", {
        ref: "bgm",
        class: "bgm",
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleBgm && _ctx.toggleBgm(...args)))
      }, [
        _createElementVNode("audio", _hoisted_21, null, 512),
        _hoisted_22,
        _hoisted_23
      ], 512),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          class: "close",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isMenuOpen = false))
        })
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("p", _hoisted_27, [
            _createTextVNode(_toDisplayString(_ctx.name), 1),
            _hoisted_28,
            _hoisted_29,
            _hoisted_30,
            _hoisted_31
          ]),
          _hoisted_32
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.link('/about')))
          }, "ジョーズ・タウンの楽しみ方"),
          _createElementVNode("li", {
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeMenuAndOpenMap && _ctx.closeMenuAndOpenMap(...args)))
          }, "パビリオン選択"),
          _createElementVNode("li", {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.link('/tutorial')))
          }, "チュートリアル"),
          _hoisted_33,
          _hoisted_34,
          _hoisted_35,
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_36, "よくあるご質問", 512)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_37, "住まいに関するお問い合わせ", 512)
          ]),
          _hoisted_38,
          _createElementVNode("li", {
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeMenuAndOpenDialog && _ctx.closeMenuAndOpenDialog(...args)))
          }, "ログアウト")
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("p", null, [
            _hoisted_41,
            _createElementVNode("a", _hoisted_42, "こちら", 512)
          ]),
          _createElementVNode("p", null, [
            _hoisted_43,
            _createElementVNode("a", _hoisted_44, "こちら", 512)
          ])
        ])
      ])
    ], 2),
    (_ctx.isDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("button", {
            class: "yes",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, _hoisted_48),
          _createElementVNode("button", {
            class: "no",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isDialog = false))
          }, _hoisted_50)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Map, {
      class: _normalizeClass([{ open: _ctx.isMapOpen }, "map"]),
      onMapClose: _ctx.toggleMap
    }, null, 8, ["class", "onMapClose"])
  ], 2))
}